import { useState, useEffect, forwardRef } from 'react'
import "./Challenges.css"
import Axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import MuiAlert from '@mui/material/Alert';
import Cookies from 'universal-cookie';
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button,  Snackbar } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const Challenges2 = () => {
    const [challenges, setChallenges] = useState([])
    const [id, setId] = useState(0)
    const [solve, setSolve] = useState('')
    const [title, setTitle] = useState('Selecciona un reto.')
    const [category, setCategory] = useState('')
    const [description, setDescription] = useState('- Lee detenidamente, resuelve el reto e ingresa la flag! ')
    const [link, setLink] = useState('')
    const [value, setValue] = useState(0)
    const [openDialogHint, setOpenDialogHint] = useState(false);
    const [openDialogMessage, setOpenDialogMessage] = useState(false);
    const [hintID, setHintID] = useState(0);
    const [hintMessage, setHintMessage] = useState('');
    const [hintCost, setHintCost] = useState(0);
    const [iconImg, setIconImg] = useState('/arrowLeft.png')
    const [solvedChall, setSolvedChall] = useState([])
    const [hintRecords, setHintRecords] = useState([])
    const [showHints, setShowHints] = useState(0)
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');

    //Alerts
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const { id_challs } = useParams();
    const [competition, setCompetition] = useState(false)
    const history = useHistory();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenError(false);
        setOpenSuccess(false);
    };
    const handleCloseDialogHint = () => {
        setOpenDialogHint(false);
        setHintID(0);
      };
      const handleCloseDialogMessage = () => {
        setOpenDialogMessage(false);
        setHintID(0);
      };
    useEffect(() => {


        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/getChallengesCategory`, { category_id: id_challs }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {
                if (response.data.messageFinish) {
                    setCompetition(false);
                    setChallenges([]);
                }
                else if (response.data.messageInit) {
                    setCompetition(false);
                    setChallenges([]);
                }
                else if (response.data.messageNot) {
                    setCompetition(false);
                    setChallenges([]);
                }
                else {
                    setChallenges(response.data)
                    setCompetition(true)
                }
            }
        });
        Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/solvedChallenges`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response) {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                
                    if (response.data.messageFinish) {
                        setSolvedChall([]);
                    }
                    else if (response.data.messageInit) {
                        setSolvedChall([]);
                    }
                    else if (response.data.messageNot) {
                        setSolvedChall([]);
                    }
                    else {
                        setSolvedChall(response.data)
                    }

                
            }
        }
        );
    }, []);
    const getHints = (id) => {
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/getHints`, { challenge_id: id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            console.log(response)
            if (response) {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (response.data.messageFinish) {
                        setHintRecords([]);
                        setShowHints(0);
                    }
                    else if (response.data.messageInit) {
                        setHintRecords([]);
                        setShowHints(0);
                    }
                    else if (response.data.messageNot) {
                        setHintRecords([]);
                        setShowHints(0);
                    }
                    else {
                        setHintRecords(response.data)
                        setShowHints(response.data[0].hint_id)
                    }
                }
            }
        });
    }
    function ShowChallenges() {
        let items2 = []
        for (let [ky, valor] of Object.entries(challenges)) {
            let solved = false;
            for (let [ky2, valor2] of Object.entries(solvedChall)) {
                if (valor.challenge_id == valor2.challenge_id) {
                    solved = true;
                    break;
                }
            }
            if (solved) {
                items2.push(<div className="challenge" key={ky} onClick={() => {
                    setId(valor.challenge_id)
                    setTitle(valor.name)
                    setDescription(valor.description)
                    setCategory(valor.title)
                    setValue(valor.value)
                    setLink(valor.link)
                    setIconImg("/imgChallenge/retoResuelto.jpg")
                    getHints(valor.challenge_id)
                    setSolve('')
                }}><img src={"/imgChallenge/retoResuelto.jpg"} alt='hi' />
                    <div className="top-right">{valor.value}</div>
                    <div className="challenge-name"><h5>{valor.name}</h5></div>
                </div>)

            }
            else {
                items2.push(<div className="challenge" key={ky} onClick={() => {
                    setId(valor.challenge_id)
                    setTitle(valor.name)
                    setDescription(valor.description)
                    setCategory(valor.title)
                    setValue(valor.value)
                    setLink(valor.link)
                    setIconImg(valor.icon)
                    getHints(valor.challenge_id)
                    setSolve('')
                }}><img src={valor.icon} alt='hi' />
                    <div className="top-right">{valor.value}</div>
                    <div className="challenge-name"><h5>{valor.name}</h5></div>
                </div>)

            }


        }
        return items2;

    }

    //challenges


    const getHint1 = (id, cost) => {
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/getOpenHint`,
            { hint_id: id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.messageError) {
                setHintID(id);
                setHintCost(cost)
                setOpenDialogHint(true);
                setOpenDialogMessage(false);
            }
            else {
                setHintMessage(response.data[0].hint);
                setOpenDialogMessage(true);
                setOpenDialogHint(false);
            }

        });
    }

    const getInsertHint = (id) => {
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/getNewHint`,
            { hint_id: id }, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.messageError) {
                setErrorMessage(response.data.messageError);
                setOpenError(true);
            }
            else {
                setHintMessage(response.data[0].hint);
                setOpenDialogMessage(true);
                setOpenDialogHint(false);
            }

        });
    }
    const solveChallenge = () => {
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/challengeSolve`, { id: id, solve: solve }, {
            headers: { 'Authorization': userToken }
        }
        ).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (response.data.messageSuccess) {
                    setOpenSuccess(true);
                    setSuccessMessage(response.data.messageSuccess);
                    setSolve('')
                }
                else if (response.data.messageError) {
                    setOpenError(true);
                    setErrorMessage(response.data.messageError);
                    setSolve('')
                }
                else if (response.data.messageFinish) {
                    setOpenError(true);
                    setErrorMessage('La competición ha finalizado');
                    setSolve('')
                }
                else if (response.data.messageInit) {
                    setOpenError(true);
                    setErrorMessage('La competición aún no ha iniciado');
                    setSolve('')
                }
                else {
                    setErrorMessage('');
                    setSuccessMessage('');
                    setOpenError(false);
                    setOpenSuccess(false);
                }
            }

        });

    }


    return (

        <div className="screen-challenges">

            <div className={ competition ? "dashboard" : "dashboard displayNone2"} >
                <div className="challenges-screen" >
                    {ShowChallenges()}

                </div>
                <div className='previous-chall' >
                    <button onClick={(e) => { history.push('/user/retos') }} className="buttonDisplayStyle">Atrás</button>
                </div>
            </div>

            <div className={ competition ? "right-screen" : "right-screen displayNone2"}>

                <div className="challenge-card" >
                    <div className="info-container" >
                        <div className="info-left">
                            <h2>{title}</h2>
                            <h5> {category ? `Categoría:${category}` : ''}</h5>
                            <h5> {value ? `Puntos:${value}` : ''}</h5>
                        </div>
                        <div className="info-right">
                            <img src={iconImg} className="img-card" />
                        </div>
                    </div>
                    <div className="challenge-description">
                        <p >{description}</p>
                        <br />
                        <div className="divStyling3">
                            {showHints != 0 ? hintRecords.map((hint, index) => {
                                return (
                                    <Button key={index} variant="outlined" color="primary" className="divStyling3" onClick={(e) => { getHint1(hint.hint_id, hint.cost) }}> Pista {hint.num}</Button>

                                )
                            }) :
                                ''}
                        </div>
                    </div>
            
                    <a href={link} target="_blank" rel="noopener noreferrer" download>
                        <button className="challenge-file" hidden={link? false : true} disabled={link ? false : true} >DESCARGAR ARCHIVO</button>
                    </a>


                </div>
                <div className="submit">
                    <input placeholder={title ? "Ingresar la flag aquí" : ''} disabled={title ? false : true} value={solve} className="submit-challenge" onChange={(e) => {
                        setSolve(e.target.value)
                    }} />
                    <div className="but">
                        <button className="button-challenge" disabled={title ? false : true} onClick={solveChallenge}><SendIcon className="icon" /></button>
                    </div>
                </div>

            </div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="alertWidthTop">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="alertWidthTop">
                    {success}
                </Alert>
            </Snackbar>
            <Dialog
                open={openDialogHint}
                onClose={handleCloseDialogHint}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Pista"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Está seguro que desea ver la pista?
                       <br/> Costo: {hintCost} puntos.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => { getInsertHint(hintID) }}>Sí</Button>
                    <Button onClick={handleCloseDialogHint} autoFocus>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogMessage}
                onClose={handleCloseDialogMessage}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Pista"} 
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {hintMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogMessage} autoFocus>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>


    )
}

export default Challenges2